import { render, staticRenderFns } from "./LandingPageV2.vue?vue&type=template&id=1394d594&scoped=true&"
import script from "./LandingPageV2.vue?vue&type=script&lang=js&"
export * from "./LandingPageV2.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageV2.vue?vue&type=style&index=0&id=1394d594&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394d594",
  null
  
)

export default component.exports